export default "/images/vendor/flag-icon-css/flags/4x3/bf.svg?a3957b0a98236111e2377ac4bc638574";